import React from "react";
import List from "../components/List";
import hipladeTemplate from "../../common/template";

function ThemesList() {
  return <List />;
}

export default hipladeTemplate(ThemesList);
